export const UNAUTHORIZED_ERROR_CODE = 401;
